import React from 'react';
import { useWellmedService } from '~/services/WellmedService';

export function EprgNavLink() {
    const { getEprgUrl } = useWellmedService();
    const [eprgUrl, setEprgUrl] = React.useState<string | null>(null);

    React.useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const { eprg_url } = await getEprgUrl();
                if (!cancelled) {
                    setEprgUrl(eprg_url?.trim() || null);
                }
            } catch {
                if (!cancelled) {
                    setEprgUrl(null);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [getEprgUrl]);

    if (!eprgUrl) {
        return null;
    }

    return (
        <a
            id="nav-eprg"
            className="nav-link"
            href={eprgUrl}
            target="_blank"
            rel="noopener noreferrer"
        >
            ePRG
        </a>
    );
}
